var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingapore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18418_78201)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18418_78201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7619 -0.253906H0V32.2533H48.7619V-0.253906Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7619 -0.253906H0V15.9997H48.7619V-0.253906Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95008 8.94686C7.95008 6.57876 9.61446 4.60048 11.8369 4.11505C11.4953 4.04038 11.1409 4 10.7769 4C8.04475 4 5.83008 6.21467 5.83008 8.94676C5.83008 11.6789 8.04484 13.8936 10.7769 13.8936C11.1409 13.8936 11.4953 13.8531 11.8369 13.7786C9.61446 13.2933 7.95008 11.315 7.95008 8.94686Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3104 4.35352L14.6613 5.43323H15.7966L14.878 6.10056L15.2289 7.18028L14.3104 6.51304L13.3918 7.18028L13.7428 6.10056L12.8242 5.43323H13.9596L14.3104 4.35352Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5565 6.47363L11.9073 7.55335H13.0426L12.124 8.22068L12.4749 9.30039L11.5565 8.63316L10.6379 9.30039L10.9889 8.22068L10.0703 7.55335H11.2056L11.5565 6.47363Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0652 6.47363L17.4161 7.55335H18.5514L17.6328 8.22068L17.9837 9.30039L17.0652 8.63316L16.1467 9.30039L16.4977 8.22068L15.5791 7.55335H16.7144L17.0652 6.47363Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0036 9.65381L16.3544 10.7335H17.4898L16.5713 11.4009L16.9221 12.4806L16.0036 11.8133L15.0852 12.4806L15.4361 11.4009L14.5176 10.7335H15.6528L16.0036 9.65381Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.617 9.65381L12.9677 10.7335H14.103L13.1846 11.4009L13.5354 12.4806L12.617 11.8133L11.6985 12.4806L12.0493 11.4009L11.1309 10.7335H12.2661L12.617 9.65381Z",
    fill: "#F0F0F0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18418_78201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18418_78201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.7619,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingapore);
export default __webpack_public_path__ + "static/media/singapore.57ad830ae4424d1a28d13be041091495.svg";
export { ForwardRef as ReactComponent };